import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkedin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 78,
	height: 78,
	viewBox: "0 0 78 78",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 38.8243,
		cy: 38.8243,
		rx: 38.8243,
		ry: 38.8243,
		fill: "#0077B7"
	}), /* @__PURE__ */ _jsx("path", {
		transform: "translate(18.6 18.6) scale(1.7)",
		d: "M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z",
		fill: "white"
	})]
});
export default SvgLinkedin;
